export const formatCurrency = (value, currency = 'BRL') => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: currency
  }).format(value);
};

export const formatNumber = (value) => {
  return new Intl.NumberFormat('pt-BR').format(value);
};

export const formatPercent = (value) => {
  return `${parseFloat(value).toFixed(2)}%`;
};

// Frequência média (impressões por pessoa). null/ausente -> "—".
export const formatFrequency = (value) => {
  if (value === null || value === undefined || value === '') return '—';
  const n = parseFloat(value);
  return isNaN(n) ? '—' : `${n.toFixed(2)}x`;
};

// Custo por conversa: moeda quando há valor; "—" quando null/ausente.
export const formatCostPerConversation = (value, currency = 'BRL') => {
  if (value === null || value === undefined || value === '') return '—';
  const n = parseFloat(value);
  return isNaN(n) ? '—' : formatCurrency(n, currency);
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
};

export const formatShortDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'short'
  });
};
